var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoupleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30.611,
  height: 29,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#couple-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.956 13.569a5.526 5.526 0 0 0 5.52-5.52 5.526 5.526 0 0 0-5.518-5.521 5.526 5.526 0 0 0-5.521 5.521 5.526 5.526 0 0 0 5.521 5.52m0-8.995a3.48 3.48 0 0 1 3.474 3.475 3.48 3.48 0 0 1-3.474 3.475 3.48 3.48 0 0 1-3.475-3.475 3.48 3.48 0 0 1 3.475-3.475M21.655 13.569a5.526 5.526 0 0 0 5.521-5.52 5.526 5.526 0 0 0-5.521-5.521 5.526 5.526 0 0 0-5.52 5.521 5.526 5.526 0 0 0 5.52 5.52m0-8.995a3.48 3.48 0 0 1 3.475 3.475 3.48 3.48 0 0 1-3.475 3.475 3.48 3.48 0 0 1-3.475-3.475 3.48 3.48 0 0 1 3.475-3.475"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.306 17.572c-4.777-5.95-14.5-2.578-14.5 5.114v2.763c0 .564.458 1.023 1.023 1.023h26.954c.564 0 1.023-.458 1.023-1.023v-2.763c0-7.693-9.729-11.059-14.5-5.114m-.246 6.854H2.852v-1.74a6.11 6.11 0 0 1 6.104-6.104 6.096 6.096 0 0 1 6.103 6.104zm12.7 0H17.106c0-1.911.122-3.119-.651-4.938a6.07 6.07 0 0 1 5.201-2.906 6.11 6.11 0 0 1 6.106 6.104z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "couple-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h29v29H.5z"
})))));
export default SvgCoupleIcon;